import React, {
  useContext, useRef,
  useEffect, useState,
} from 'react';
import classNames from 'classnames';
import { KickCounterContext } from '../../../context/KickCounterContext';
import DebounceButton from '../../button/DebounceButton';
import StopWatch from '../../time/StopWatch';
import KickInput from './KickInput';
import Modal from '../../modal/Modal';
import styles from './MainPanel.module.css';
import COLORS from '../../../constants/colors';
import Tutorial from '../../info/Tutorial';
import useEndSession from '../../../hooks/useEndSession';
import sharedButtonStyles from '../../button/Button.module.css';
import Tooltip from '../../tooltip/Tooltip';
import { TOOLTIP } from '../../../constants/strings';

const infoIcon = require('../../../assets/icons/info_icon_yellow.svg').default;
const pauseIcon = require('../../../assets/icons/pause.svg').default;
const playIcon = require('../../../assets/icons/play.svg').default;

export default function MainPanel() {
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [showTutorial, setShowTutorial] = useState(false);
  const {
    addKick, kickList, time, setCounterActive, active,
  } = useContext(KickCounterContext);
  const timeByRef = useRef(0);
  const activeByRef = useRef(false);
  const sessionShouldEnd = useEndSession();

  timeByRef.current = time;
  activeByRef.current = active;

  const onPress = (value) => {
    addKick(value, timeByRef.current);
  };

  const onTutorialCancel = () => {
    setShowTutorial(false);
  };

  useEffect(() => {
    if (sessionShouldEnd) {
      setButtonDisabled(true);
      setCounterActive(false);
    }
  }, [active, sessionShouldEnd]);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.summaryContainer}>
        <div className={styles.movementContainer}>
          <span className={styles.movementCount}>{kickList.length}</span>
          <span>Total Movements</span>
        </div>
        <div className={styles.stopWatchContainer}>
          <span>Time Elapsed:&nbsp;</span>
          <StopWatch active={active} />
        </div>
      </div>
      <div className={styles.startContainer}>
        <div className={styles.infoButtonContainer} data-tip={TOOLTIP.COUNTER_TUTORIAL}>
          <button
            type="button"
            className="infoButton"
            onClick={() => setShowTutorial(true)}
          >
            <img src={infoIcon} alt="" />
            &nbsp;How do I use this tool?
          </button>
        </div>
        <DebounceButton
          disabled={buttonDisabled}
          className={classNames(
            styles.startButton,
            sharedButtonStyles.FCButtonEnabled,
            sharedButtonStyles.medium,
          )}
          onClick={() => setCounterActive(!activeByRef.current)}
        >
          {!active ? (
            <>
              <img src={playIcon} alt="" />
              &nbsp;&nbsp;Start Timer
            </>
          ) : (
            <>
              <img src={pauseIcon} alt="" />
              &nbsp;&nbsp;Pause Timer
            </>
          )}
        </DebounceButton>
      </div>
      <div className={styles.instructionText}>
        Add a movement type by clicking one of the buttons below:
      </div>
      <div className={styles.kickInputContainer}>
        <KickInput
          onPress={onPress}
          disabled={!active}
        />
      </div>
      { showTutorial && (
        <Modal showBar={false} backgroundColor={COLORS.backgroundGray} borderRadius="4px" maxWidth={760}>
          <Tutorial onCancel={onTutorialCancel} />
        </Modal>
      )}
      <Tooltip />
    </div>
  );
}
